import React from 'react';
import { Image } from '../image/Image';
import { CoreListItem } from '../types/data';
import { TCoreOptions } from '../types/options';
import styles from './list.module.css';

type CoreListLeadingElProps = {
    item: CoreListItem;
    palette: TCoreOptions;
    dataTestId: string;
};

const CoreListLeadingEl = ({ item, palette, dataTestId }: CoreListLeadingElProps) => {
    let content = null;
    if (item.leadingVideoThumbnail) {
        content = <Image dataTestId={dataTestId} src={item.leadingVideoThumbnail} width={56} height={56} />;
    }
    if (item.leadingAvatarUrl || item.leadingAvatarLabel) {
        content = (
            <Image
                src={item.leadingAvatarUrl ?? '#'}
                width={40}
                height={40}
                iconColor={palette.mainContainer}
                backgroundColor={palette.onSurfaceVariant}
                label={item.leadingAvatarLabel?.substring(0, 2).toUpperCase()}
                dataTestId={dataTestId}
            ></Image>
        );
    }

    if (item.leadingIcon) {
        content = <Image src={item.leadingIcon} width={24} height={24} iconColor={palette.surfaceVariant} dataTestId={dataTestId} />;
    }
    if (content) {
        return <div className={styles.leading}>{content}</div>;
    }
    return null;
};

export { CoreListLeadingEl };
